import React from "react";

const Phonebar = ({
}) => {
  return (
    <div className="w-full bg-JMJGray text-white">
      <div className="flex flex-col md:flex-row items-center md:items-center justify-between px-4 py-2 gap-2 md:gap-0">
        <div className="flex flex-col md:flex-row items-center md:items-baseline gap-y-1 md:gap-y-0 md:gap-x-6 text-md md:text-base font-bold text-center md:text-left">
          <p>
            Orlando:{" "}
            <a href="tel:+14078390620" className="underline">
              (407) 839-0620
            </a>
          </p>
          <p>
            Kissimmee:{" "}
            <a href="tel:+14072015085" className="underline">
              (407) 201-5085
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Phonebar;
